export const getCountData = async () => {
  try {
    const response = await fetch('/api/counts', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return {
      total_people: Number(data.total_people) || 0,
      total_count: Number(data.total_count) || 0,
      total_center: Number(data.total_center) || 0,
      total_store: Number(data.total_store) || 0,
      date: data.date || '',
      special_donation: data.special_donation || ''
    };
  } catch (error) {
    console.error('API Error:', error);
    return {
      total_people: 0,
      total_count: 0,
      total_center: 0,
      total_store: 0,
      date: '',
      special_donation: ''
    };
  }
};

export const getStoryDatabase = async () => {
  try {
    const response = await fetch('/api/stories', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (!Array.isArray(data)) {
      console.error('Unexpected data format:', data);
      return [];
    }

    // 서버에서 정렬된 데이터를 그대로 반환
    return data;
  } catch (error) {
    console.error('API Error:', error);
    return [];
  }
};